import { Reveal } from "./Reveal";
import { WhatsGlyph } from "./WhatsGlyph";
import { IMAGES, waLink, DEFAULT_MSG, WHATSAPP_DISPLAY } from "@/data/site";

export const CtaBand = () => (
  <section className="relative py-10 pb-24 sm:pb-28" data-testid="cta-band">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="relative grid grid-cols-1 overflow-hidden rounded-[2.5rem] border border-white/10 bg-surface lg:grid-cols-12">
          <div className="relative z-10 flex flex-col justify-center p-10 sm:p-14 lg:col-span-7 lg:p-16">
            <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-neon/10 blur-[100px]" aria-hidden="true" />
            <p className="font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-wa">
              Só falta você
            </p>
            <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.98] tracking-tight text-white sm:text-5xl lg:text-6xl">
              Pronto para assistir sem travar?
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-mist">
              Manda um “oi” no WhatsApp e comece a assistir hoje mesmo. A
              ativação leva minutos.
            </p>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
              <a
                href={waLink(DEFAULT_MSG)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-whatsapp-cta"
                className="inline-flex items-center justify-center gap-3 rounded-full bg-wa px-8 py-4 font-display text-lg font-bold uppercase tracking-wider text-[#052e16] shadow-[0_12px_40px_-10px_rgba(37,211,102,0.55)] transition-colors hover:bg-wa-hover"
              >
                <WhatsGlyph className="h-5 w-5" />
                Chamar no WhatsApp
              </a>
              <span
                className="font-mono text-sm tracking-wider text-white/80"
                data-testid="whatsapp-number-display"
              >
                {WHATSAPP_DISPLAY}
              </span>
            </div>
          </div>
          <div className="relative min-h-[260px] lg:col-span-5">
            <img
              src={IMAGES.remote}
              alt="Controle remoto apontando para a TV"
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  "linear-gradient(to right, rgba(14,17,27,1) 0%, rgba(14,17,27,0.4) 35%, transparent 70%)",
              }}
              aria-hidden="true"
            />
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
